import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { PageUploadTiles } from '../-components/PageUploadTiles'
import { useCoreUploadTiles } from '../-hooks/useCoreUploadTiles'
import { AUTO_INJECT_UPLOAD_TYPES } from './-upload-types'

export const Route = createFileRoute('/_auth/_modules/_app/core-upload-data/auto-inject/')({
  component: RouteComponent,
})

function RouteComponent() {
  const { t } = useTranslation('uploads')
  const tiles = useCoreUploadTiles(AUTO_INJECT_UPLOAD_TYPES)

  return (
    <PageUploadTiles
      tiles={tiles}
      header={t('uploadData.autoInject.title')}
      description={t('uploadData.autoInject.description')}
    />
  )
}
